// src/hooks/useFavorites.js
// Gestion des favoris persistés dans localStorage.

import { useState, useEffect } from 'react';

const STORAGE_KEY = 'messy_favorites';

export function useFavorites() {
  const [favs, setFavs] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch { return []; }
  });

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(favs)); }
    catch {}
  }, [favs]);

  function toggle(card) {
    setFavs(prev => {
      const exists = prev.some(f => f.id === card.id);
      return exists ? prev.filter(f => f.id !== card.id) : [...prev, card];
    });
  }

  function isFav(card) { return favs.some(f => f.id === card.id); }

  return { favs, toggle, isFav };
}
